// @ts-nocheck
import moment from "moment-timezone";

export const useDatetimePickerData = (year, month, date, hour, minute, datetime, timeZone) => {
  const weeks = [0, 1, 2, 3, 4, 5, 6];
  const stashDays = new Array(6);
  let d = 1;
  let w = 0;
  stashDays[w] = [];
  const day =
    date > moment.tz([year, month, 1], timeZone).endOf("month").date()
      ? moment.tz([year, month, 1], timeZone)
      : moment.tz([year, month, date], timeZone);
  const MonthAllDays = day.daysInMonth();
  while (d <= MonthAllDays) {
    let DateTimeFormat;
    if (datetime) {
      DateTimeFormat = [year, month, d, hour, minute];
    } else {
      DateTimeFormat = [year, month, d];
    }

    const current_day = d <= MonthAllDays ? moment.tz(DateTimeFormat, timeZone).day() : null;
    weeks.forEach((_, i) => {
      if (d === 1 && i < current_day) {
        stashDays[w][i] = moment.tz(DateTimeFormat, timeZone).subtract(current_day - i, "days");
      } else if (d === MonthAllDays && i > current_day) {
        stashDays[w][i] = moment.tz(DateTimeFormat, timeZone).add(i - current_day, "days");
      } else if (current_day !== null && i === current_day) {
        stashDays[w][i] = moment.tz(DateTimeFormat, timeZone);
      }
    });

    if (moment.tz(DateTimeFormat, timeZone).day() === 6 || (d === MonthAllDays && w < 5)) {
      w += 1;
      stashDays[w] = [];
    }
    d += 1;
  }
  if (stashDays[5] && !stashDays[5].length) {
    const latestDate = stashDays[4][6];
    weeks.forEach((_, i) => {
      stashDays[5][i] = moment
        .tz(
          [latestDate.year(), latestDate.month(), latestDate.date(), latestDate.hour(), latestDate.minute()],
          timeZone,
        )
        .add(i + 1, "days");
    });
  }

  return stashDays;
};
